import React, { useEffect, useState, useRef } from "react";
import Footer from "./include/Footer";
import Header from "./include/Header";
import Sidebar from "./include/Sidebar";
import Pagination from "./include/Pagination";
import DateRangePickerComp from "./DateRangePickerComp";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { useParams } from "react-router-dom";
import Loader from "./include/Loader";

const api_baseurl = process.env.REACT_APP_BASE_URL_API

function ProfitMargin() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setQuery] = useState("");
  const [order, setOrder] = useState("ASC");
  const [searchDateRange, setDateRange] = useState("");
  const [finalDateValue, setFinalDateValue] = useState("");

  const tableRef = useRef(null);

  const params = useParams();
  let vendor_id  = atob(params.vendor_id);

  function parentAlert(demoData) {
    setDateRange(demoData);
    setFinalDateValue(searchDateRange);
  }



  function getCalendarValue() {
    setFinalDateValue(searchDateRange);
    loadData(finalDateValue);
  }

  function loadData(datefilter) {
    setLoading(true);
    fetch(
      api_baseurl+"profit_margin?vendor_id=" +
        vendor_id+
        "&date_range=" +
        datefilter
    ).then((res) => {
      res.json().then((response) => {
        setData(response);
        setLoading(false);
      });
    });
  }

  const sorting = (col)=>{

    if(order === 'ASC'){
      const sorted = data.result.sort((a,b) =>
      
      col=='sold' || col=='current_cost' || col=='sale_price' || col=='sales' || col=='profit'
         ?
         a[col].toLowerCase()-b[col].toLowerCase()
         :
         a[col].toLowerCase() > b[col].toLowerCase()? 1: -1
        
      );
      
     // setData(sorted)
      setOrder("DSC")
    }

    if(order==='DSC'){
      const sorted = data.result.sort((a,b)=>
      col=='sold' || col=='current_cost' || col=='sale_price' || col=='sales' || col=='profit'
          ?
          b[col].toLowerCase() - a[col].toLowerCase()
          :
          a[col].toLowerCase() < b[col].toLowerCase()? 1: -1
       
      );
    // setData(sorted)
      setOrder("ASC")
    }
  }

  useEffect(() => {
    getCalendarValue();
    loadData(finalDateValue);
  }, []);



  return (
    <fregment>
      <Header></Header>
      <Sidebar></Sidebar>

      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Profit Margin</h1>
          <div className="seprator"></div>
          <nav className="export-relative">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="javascript:;">Inventory Reports</a>
              </li>
              <li className="breadcrumb-item active">Profit Margin</li>
            </ol>
            <a href={api_baseurl+"profit_margin?vendor_id="+vendor_id+"&date_range="+finalDateValue+"&is_download=1"}> <button className="export-data" ><i className="icon-excel"></i> Export Data</button></a>
          </nav>
        </div>

        <section className="section">
          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="top-form">
                    <form>
                      <div className="row">
                        <div className="col date-ic">
                      <label for="selectdate"></label>
                      <DateRangePickerComp
                            alert={parentAlert}
                          ></DateRangePickerComp>
                          {/* <div className="calendar-ic">
                          <button type="button" onClick={getCalendarValue}><i className="icon-calendar-ic"></i></button>
                          </div> */}
                          <button
                            type="button"
                            className="go-btn"
                            onClick={getCalendarValue}
                          >
                            Go
                          </button>
                    </div>
                        <div className="col search-ic col-lg-6">
                          <label for="selectdate"></label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search"
                            onChange={(e) => setQuery(e.target.value)}
                          />
                          <div className="calendar-ic">
                            <button type="button">
                              <i className="icon-search"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>

                  {loading ? (
                    ""
                  ) : (
                    <section class="section pst-boxes">
                      <div class="row">
                        <div class="container text-center">
                          <div class="row row-cols-1   row-cols-lg-4 g-3 g-lg-3">
                            <div class="col">
                              <div class="cmn-box">
                                <span>Product Sold</span>
                                <h5>{data.product_sold?data.product_sold:'0'}</h5>
                              </div>
                            </div>
                            <div class="col">
                              <div class="cmn-box">
                                <span>Current Cost</span>
                                <h5>${data.current_cost?parseFloat(data.current_cost).toFixed(2):'0.00'}</h5>
                              </div>
                            </div>
                            <div class="col">
                              <div class="cmn-box">
                                <span>Sale</span>
                                <h5>${data.sale?parseFloat(data.sale).toFixed(2):'0.00'}</h5>
                              </div>
                            </div>

                            <div class="col">
                              <div class="cmn-box">
                                <span>Profit</span>
                                <h5>${data.profit?parseFloat(data.profit).toFixed(2):'0.00'}</h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  )}

                  {/*  <!-- Table with stripped rows --> */}
                  {loading ? (
                    <Loader></Loader>
                  ) : (
                    <div className="table-responsive orderid-select">
                      <table
                        class="table table-striped table-bordered"
                        rel="tableRef"
                      >
                        <thead>
                          <tr>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={() => sorting("product_name")}
                              >
                                Product Name
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={() => sorting("barcode_id")}
                              >
                                Barcode ID
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={() => sorting("brand_name")}
                              >
                                Brand
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={() => sorting("sold")}
                              >
                                Product Sold
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={() => sorting("current_cost")}
                              >
                                Current Cost
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={() => sorting("sale_price")}
                              >
                                Sale Price
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={() => sorting("sales")}
                              >
                                Sale
                              </a>
                            </th>
                            <th scope="col">
                              <a
                                class="blk dataTable-sorter"
                                href="javascript:void(0);"
                                onClick={() => sorting("profit")}
                              >
                                Profit
                              </a>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.result &&
                            data.result
                              .filter(
                                (item) =>
                                  item.product_name
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.brand_name
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.barcode_id
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.sold
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.current_cost
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                    item.sale_price
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.sales
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase()) ||
                                  item.profit
                                    ?.toLowerCase()
                                    .includes(searchQuery.toLowerCase())
                              )
                              .map((item) => (
                                <tr id={item.product_id} key={item.product_id}>
                                  <td>{item.product_name}</td>
                                  
                                  <td>{item.barcode_id}</td>
                                  <td>{item.brand_name}</td>
                                  <td>{item.sold}</td>
                                  <td style={{ textAlign: "right" }}>
                                    ${parseFloat(item.current_cost).toFixed(2)}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    ${parseFloat(item.sale_price).toFixed(2)}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    ${parseFloat(item.sales).toFixed(2)}
                                  </td>
                                  <td style={{ textAlign: "right" }}>
                                    ${parseFloat(item.profit).toFixed(2)}
                                  </td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {/* <!-- End Table with stripped rows --> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer></Footer>
    </fregment>
  );
}

export default ProfitMargin;
